export default __webpack_public_path__ + "static/The Home_Image 5_carousel 4@2x-af5ac7833e392b7b4b0dfcac121fcbcc.jpg";